import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "identifier": {
      "column": {
        "default": null,
        "name": "identifier",
        "null": false,
        "type": "string"
      },
      "name": "identifier",
      "selected_by_default": null,
      "translated": false
    },
    "translated_identifier": {
      "column": null,
      "name": "translated_identifier",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    }
  },
  "className": "Role",
  "collectionKey": "roles",
  "collectionName": "roles",
  "i18nKey": "role",
  "camelizedLower": "role",
  "name": "Role",
  "nameDasherized": "role",
  "pluralName": "roles",
  "ransackable_associations": [
    {
      "className": "Role::Audit",
      "collectionName": "role_audits",
      "foreignKey": "role_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "RoleAudit",
      "through": null
    },
    {
      "className": "Role::Audit",
      "collectionName": "role_audits",
      "foreignKey": "role_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "RoleAudit",
      "through": null
    },
    {
      "className": "Role::Translation",
      "collectionName": null,
      "foreignKey": "role_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Role::Translation",
      "collectionName": null,
      "foreignKey": "role_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "UserRole",
      "collectionName": "user_roles",
      "foreignKey": "role_id",
      "name": "user_roles",
      "macro": "has_many",
      "resource_name": "UserRole",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "identifier",
      "column": {
        "default": null,
        "name": "identifier",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "UserRole",
      "collectionName": "user_roles",
      "foreignKey": "role_id",
      "name": "user_roles",
      "macro": "has_many",
      "resource_name": "UserRole",
      "through": null
    }
  ],
  "paramKey": "role",
  "primaryKey": "id"
}

/** Frontend model for Role. */
class Role extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  identifier() {
    return this.readAttributeUnderscore("identifier")
  }

  /** @returns {boolean} */
  hasIdentifier() {
    const value = this.identifier()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedIdentifier() {
    return this.readAttributeUnderscore("translated_identifier")
  }

  /** @returns {boolean} */
  hasTranslatedIdentifier() {
    const value = this.translatedIdentifier()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./user-role.js").default>} */
  userRoles() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("UserRole")

    const ransack = {}

    ransack["role_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "user_roles",
        model: this,
        modelName: "UserRole",
        modelClass
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./user-role.js").default>>} */
  loadUserRoles() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const modelClass = modelClassRequire("UserRole")

    const ransack = {}

    ransack["role_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "user_roles",
        model: this,
        modelClass
      },
      {ransack}
    )
  }
}

export default Role
